import {InspectionFormPage} from 'modules/Inspection';

export default InspectionFormPage;
